<template>
    <div>
        <div class="riskMatrix_filter_bar mb-15">
            <div class="row">
                <div class="col-md-12">
                    <b-input-group size="sm">
                        <template #prepend>
                            <b-input-group-text style="height: 40px;">Zeitraum: </b-input-group-text>
                        </template>
                    <date-range-picker
                        ref="picker"
                        :opens="opens"
                        :locale-data="localeData"
                        :minDate="minDate" :maxDate="maxDate"
                        :singleDatePicker="singleDatePicker"
                        :timePicker="timePicker"
                        :timePicker24Hour="timePicker24Hour"
                        :showWeekNumbers="showWeekNumbers"
                        :showDropdowns="showDropdowns"
                        :autoApply="autoApply"
                        :ranges="ranges"
                        v-model="dateRange"
                        @update="updateValues"
                        @toggle="logEvent('event: open', $event)"
                        @start-selection="logEvent('event: startSelection', $event)"
                        @finish-selection="logEvent('event: finishSelection', $event)"
                        :linkedCalendars="linkedCalendars"
                    >
                    </date-range-picker>
                    </b-input-group>
                </div>
            </div>
        </div>

        <div class="riskMatrix border rounded pa-30">
            <div class="risk-matrix-header">
                <div class="risk-matrix-header__entry">
                    <div class="risk-matrix-header__title">gering</div>
                    <div class="risk-matrix-header__description">- Maßnahmen nicht erforderlich</div>
                </div>
                <div class="risk-matrix-header__entry">
                    <div class="risk-matrix-header__title">mittel</div>
                    <div class="risk-matrix-header__description">- Maßnahmen empfohlen</div>
                </div>
                <div class="risk-matrix-header__entry">
                    <div class="risk-matrix-header__title">erhöht</div>
                    <div class="risk-matrix-header__description">- Maßnahmen erforderlich</div>
                </div>
                <div class="risk-matrix-header__entry">
                    <div class="risk-matrix-header__title">hoch</div>
                    <div class="risk-matrix-header__description">- Maßnahmen sofort erforderlich</div>
                </div>
            </div>
            <div class="risk-matrix__gradient">
                <span class="risk-matrix__marker" style="left: 25%"></span>
                <span class="risk-matrix__marker" style="left: 50%"></span>
                <span class="risk-matrix__marker" style="left: 75%"></span>
                <span v-for="risiko_group in risikomeldungen_grouped">
                    <span v-bind:class="['risk_point', risiko_group['size']]"
                          :style="{ left: calc_position(risiko_group['data'][0].rpz)}"
                          v-b-popover.hover.top.html="getRiskData(risiko_group['data'])">
                        <!--<i class="ion  ion-md-alert old__ion-md-flash risk_point_cursor" v-b-popover.hover.top.html="getRiskData(risiko_group)"></i>-->
                    </span>
                </span>
            </div>
            <div class="risk-matrix__labels">
                <span style="left: 0">1</span>
                <span style="left: 25%">125</span>
                <span style="left: 50%">250</span>
                <span style="left: 75%">512</span>
                <span style="left: 100%">1000</span>
            </div>
        </div>
    </div>
</template>
<script>


// ***********  Localization ***************
import Lang from 'lang.js'

// get the data source
import translations from '../../../../vue-translations.js';

//Bsp.: lang.get('auth.btn_login'));

// ***********  Localization ***************

import DateRangePicker from 'vue2-daterange-picker'
import 'vue2-daterange-picker/dist/vue2-daterange-picker.css'

export default {
    props: ['api_risikomeldungen_url_in'],
    name: 'RiskMatrixComponent',
    components: { DateRangePicker },
    data() {
        let startDate = new Date();
        let endDate = new Date();
        startDate.setMonth(startDate.getMonth() - 12)

        let today = new Date()
        today.setHours(0, 0, 0, 0)

        let yesterday = new Date()
        yesterday.setDate(today.getDate() - 1)
        yesterday.setHours(0, 0, 0, 0);

        let thisMonthStart = startDate.getMonth();
        let thisMonthEnd = endDate.getMonth();

        return {
            auftrittswahrscheinlichkeit: [
                {
                    'label': '',
                    'color': 'bg-white',
                    'value': 0
                },
                {
                    'label': 'unwahrscheinlich',
                    'color': 'bg-success',
                    'value': 1
                },
                {
                    'label': 'sehr selten',
                    'color': 'bg-success',
                    'value': 2
                },
                {
                    'label': 'sehr selten',
                    'color': 'bg-success',
                    'value': 3
                },
                {
                    'label': 'mäßig wahrscheinlich',
                    'color': 'bg-success',
                    'value': 4
                },
                {
                    'label': 'mäßig wahrscheinlich',
                    'value': 5,
                    'color': 'bg-success'
                },
                {
                    'label': 'mäßig wahrscheinlich',
                    'value': 6,
                    'color': 'bg-success'
                },
                {
                    'label': 'sehr wahrscheinlich',
                    'value': 7,
                    'color': 'bg-success'
                },
                {
                    'label': 'sehr wahrscheinlich',
                    'value': 8,
                    'color': 'bg-success'
                },
                {
                    'label': 'sicher',
                    'value': 9,
                    'color': 'bg-success'
                },
                {
                    'label': 'sicher',
                    'value': 10,
                    'color': 'bg-success'
                },
            ],
            schadensausmass: [
                {
                    'label': '',
                    'color': 'bg-white',
                    'value': 0
                },
                {
                    'label': 'Nicht/kaum wahrnehmbar',
                    'color': 'bg-success',
                    value: 1
                },
                {
                    'label': 'Nicht/kaum wahrnehmbar',
                    'color': 'bg-success',
                    value: 1
                },
                {
                    'label': 'Nicht/kaum wahrnehmbar',
                    'color': 'bg-success',
                    value: 1
                },
                {
                    'label': 'Nicht/kaum wahrnehmbar',
                    'color': 'bg-success',
                    value: 1
                },
                {
                    'label': 'Nicht/kaum wahrnehmbar',
                    'color': 'bg-success',
                    value: 1
                },
                {
                    'label': 'Nicht/kaum wahrnehmbar',
                    'color': 'bg-success',
                    value: 1
                },
                {
                    'label': 'Nicht/kaum wahrnehmbar',
                    'color': 'bg-success',
                    value: 1
                },
                {
                    'label': 'Nicht/kaum wahrnehmbar',
                    'color': 'bg-success',
                    value: 1
                },
                {
                    'label': 'Nicht/kaum wahrnehmbar',
                    'color': 'bg-success',
                    value: 1
                },
                {
                    'label': 'Nicht/kaum wahrnehmbar',
                    'color': 'bg-success',
                    value: 1
                }
            ],
            lang: null,
            dateRange: {startDate, endDate},
            opens: "right",
            minDate: null,
            maxDate: null,
            singleDatePicker: false,
            timePicker: false,
            timePicker24Hour: false,
            showWeekNumbers: true,
            showDropdowns: true,
            autoApply: true,
            linkedCalendars:false,
            dateFormat:null,
            localeData: {
                direction: 'ltr',
                format: 'dd.mm.yyyy',
                separator: ' - ',
                applyLabel: 'Anwenden',
                cancelLabel: 'Abbrechen',
                weekLabel: 'W',
                customRangeLabel: 'Benutzerdefiniert',
                daysOfWeek: ['So','Mo', 'Di', 'Mi', 'Do', 'Fr', 'Sa'],
                monthNames: ['Jan', 'Feb', 'Mrz', 'Apr', 'Mai', 'Jun', 'Jul', 'Aug', 'Sep', 'Okt', 'Nov', 'Dez'],
                firstDay: 1
            },
            ranges: false,
            risikomeldungen_grouped:[],
        }
    },
    filters: {
        dateCell (value) {
            let dt = new Date(value)
            return dt.getDate()
        },
        date (val) {
            return val ? val.toLocaleString() : ''
        },
    },
    computed: {},
    created() {
        var lang = new Lang();
        lang.setLocale(this.locale_in);
        if (lang.getLocale() === 'undefined') {
            lang.setLocale('de');
        }

        lang.setMessages(translations);
        this.lang = lang;

        this.get_risiko_meldungen();
    },
    mounted() {

    },
    methods: {
        get_risiko_meldungen(){
            let url = this.api_risikomeldungen_url_in;
            self = this;

            axios.post(url,{
                start_date: this.dateRange.startDate,
                end_date: this.dateRange.endDate,
            })
                .then(function (res) {
                    self.risikomeldungen_grouped = res.data;
                })
                .catch(function (error) {
                    console.error(error);
                });
        },
        updateValues(){
            this.get_risiko_meldungen();
        },
        logEvent(){},
        calc_position(value) {
            const breakpoint_a = {value: 250, percentage: 0.5};
            const breakpoint_b = {value: 512, percentage: 0.75};
            const max_value = 1000;

            let percentage

            if (value <= breakpoint_a['value']) {
                percentage = value / (breakpoint_a['value'] / breakpoint_a['percentage']);
            }
            else if (value <= breakpoint_b['value']) {
                const compressed_portion = (value - breakpoint_a['value']) / ((breakpoint_b['value'] - breakpoint_a['value']) / (breakpoint_b['percentage'] - breakpoint_a['percentage']));
                percentage = breakpoint_a['percentage'] + compressed_portion
            }
            else {
                const compressed_portion = (value - breakpoint_b['value']) / ((max_value - breakpoint_b['value']) / (1 - breakpoint_b['percentage']));
                percentage = breakpoint_b['percentage'] + compressed_portion
            }

            return percentage*100 + '%';
        },
        getRiskData(risiko_group) {
            let message = '<div class="risk-data__container">';

            risiko_group.forEach((risiko, index) => {
                message = message +
                    '<div>' +
                        '<a href="' + risiko.meldung_url + '">' +
                            '<strong class="risk-data__ticket">' + risiko.meldung_ticket + '</strong>' +
                            ' RPZ: ' + risiko.rpz +
                        '</a>' +
                    '</div>';
            })

            return message + '</div>';
        }
    },
}
</script>

<style lang="scss">

    .risk_point_cursor {
        cursor: pointer;
    }

    div.riskMatrix {

        .risk-matrix-header {
            width: 100%;
            display: flex;

            .risk-matrix-header__entry {
                width: 25%;
                padding-right: 15px;
                padding-left: 5px;
            }

            .risk-matrix-header__title {
                font-weight: bold;
            }

            .risk-matrix-header__description {
                font-size: 12px;
            }
        }

        .risk-matrix__gradient {
            padding: 30px 0;
            margin: 10px 0;
            width: 100%;
            position: relative;
            background-image: linear-gradient(90deg, rgba(34, 175, 71, 1) 10%, rgba(255, 191, 54, 1) 25%, rgba(255, 191, 54, 1) 35%, rgba(248, 63, 55, 1) 90%);
            border: 1px solid black;

            .risk-matrix__marker,
            .risk_point {
                transform: translate(0, -50%);
                position: absolute;
            }

            .risk-matrix__marker {
                height: 100%;
                width: 0;
                border-right: 1px dashed black;
            }

            .risk_point {
                //box-shadow: 0 0 15px #ffee10;
                //color: #ffee10;
                //box-shadow: 0 0 5px #ffee10;
                //text-shadow: 0 0 5px #ffee10;

                border-radius: 50%;

                //background-color: #00acf0;
                background-color: #ffee10;
                box-shadow: 0 0 5px #00000080;

                &.risk-group--s {
                    width: 7px;
                    height: 7px;
                }

                &.risk-group--m {
                    width: 12px;
                    height: 12px;
                }

                &.risk-group--l {
                    width: 15px;
                    height: 15px;
                }
            }
        }

        .risk-matrix__labels {
            width: 100%;
            height: 1.5em;
            position: relative;

            span {
                position: absolute;
                transform: translate(-50%, 0);
            }
        }
    }

    .risk-data__container {
        a {
            display: flex;
            color: #324148;
            border-bottom: 1px solid #ffffff00;

            &:hover {
                border-bottom: 1px solid #324148;
                //text-decoration: underline !important;
            }
        }

        .risk-data__ticket {
            display: block;
            min-width: 70px;
        }
    }

</style>
